<template>
    <div id="footer" class="f14">
        <span>通讯地址：{{address}}</span>
        <span>邮编：{{post}}</span>
        <span>{{signature}}</span>
        <span>京ICP备19042963号-1</span>
    </div>
</template>

<script>
export default {
    name:"Footer",
    data () {
        return {

        };
    },
    computed:{
        address:{
            get(){
                return this.$store.state.address
            },
        },  // 地址
        signature:{
            get(){
                return this.$store.state.signature
            },
        }, // 监制
        post:{
            get(){
                return this.$store.state.post
            },
        },
    },
    methods: {

    }
}

</script>
<style lang="less" scoped>
    #footer {
        width: 100%;
        height: 31px;
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        background-color: #2F639A;
        line-height: 31px;
        color: #f0f0f3;
        span {
            margin-right: 50px;
        }
    }
</style>